module.exports = __webpack_public_path__ + "media/images/people/boy-9-ea35ad2c9e67f3821eafcd0148dfe44b.webp";